module.exports = __webpack_public_path__ + "static/media/bgDefaultLogin.468a094b.jpg";